<template>
  <Popup ref="popup" minHeight="100%" title="审核">
    <content :top="50" :bottom="showLoading ? 0 :76">
      <Loading v-if="showLoading" :isLoading="isLoading" @reload="getDataLoading" />
      <div class="popup-content">
        <div class="title">
          <span>{{deatil.deptName}}</span>
          <span>{{deatil.groupName}}</span>
          <span>{{deatil.empName}}</span>
        </div>
        <van-cell-group>
          <van-cell title="用户名" :value="deatil.companyName" />
          <van-cell title="地区" :value="deatil.address" />
        </van-cell-group>
        <van-checkbox-group v-model="checked">
          <van-cell-group title="产品">
            <van-cell
              v-for="item in deatil.goodList"
              clickable
              :key="item.goodsId"
              :title="item.goodsName"
            >
              <template #right-icon>
                <van-checkbox :name="item.goodsId"/>
              </template>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
        <van-cell-group title=" ">
          <van-cell title="原供应商" :value="deatil.oldSupply === '' ? '暂无' : deatil.oldSupply" />
          <van-cell title="开拓理由" :value="deatil.reason" />
        </van-cell-group>
      </div>
    </content>
    <div v-if="!showLoading" class="btn-fixed">
      <van-row gutter="16">
        <van-col span="12">
          <van-button block type="danger" :loading="noLoading" loading-text="请稍后..." :disabled="noLoading" native-type="button" @click="handleNoClick">
            不通过
          </van-button>
        </van-col>
        <van-col span="12">
          <van-button block type="primary" :loading="passLoading" loading-text="请稍后..." :disabled="passLoading" native-type="button" @click="handlePassClick">
            通过
          </van-button>
        </van-col>
      </van-row>
    </div>
  </Popup>
</template>

<script>
import { Toast } from 'vant'
import { reactive, ref, watch } from 'vue'
import { getAuditDetail, rejectCustome, approveCustomer } from '@/api/chome'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
import { useSubmit } from '@/hooks/useSubmit'
export default {
  name: 'ExaminePopup', // 审核
  props: {
    title: {
      type: String
    },
    departId: {
      type: String
    }
  },
  emits: ['submit-values'],
  setup (props, { emit }) {
    // 选择产品
    const checked = ref([])
    watch(checked, (val) => {
      params.goodlist = val
    })
    // 获取审核详情
    const params = reactive({
      userId: '',
      groupId: '',
      goodlist: checked.value
    })
    const deatil = ref({})
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(getAuditDetail, (data) => {
      deatil.value = data
      params.groupId = data.groupId
    }, params)

    // popup
    const popup = ref(null)
    const init = ref(() => {})
    const showPopup = ({ userId }, fun) => {
      params.userId = userId
      init.value = fun
      popup.value.show = true
      getDataLoading()
    }
    const hidePopup = () => {
      popup.value.show = false
    }

    // 提交不通过
    const noLoading = ref(false)
    const handleNoClick = () => {
      const { loading, onSubmit } = useSubmit(rejectCustome, params, () => {
        hidePopup()
        init.value()
      })
      watch(loading, (val) => {
        noLoading.value = val
      })
      onSubmit()
    }

    // 提交通过
    const passLoading = ref(false)
    const handlePassClick = () => {
      if (checked.value.length) {
        const { loading, onSubmit } = useSubmit(approveCustomer, params, () => {
          hidePopup()
          init.value()
        })
        watch(loading, (val) => {
          passLoading.value = val
        })
        onSubmit()
      } else {
        Toast('请先选择产品')
      }
    }
    return {
      popup,
      showPopup,
      hidePopup,
      getDataLoading,
      showLoading,
      isLoading,
      deatil,
      checked,
      handleNoClick,
      handlePassClick,
      noLoading,
      passLoading
    }
  }
}
</script>

<style lang="scss" scoped>

.popup-content {
  .title {
    font-size: 14px;
    padding: 16px;
    color: #666;
    background-color: #fff;
    margin: 16px 0;
    span {
      margin-right: 5px;
    }
    span:last-child{
      font-weight: 600;
      color: #333;
    }
  }
}
.btn-fixed {
  margin: 16px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>
